import { render, staticRenderFns } from "./AccountGroupEditModal.vue?vue&type=template&id=3bbbc6fe&"
import script from "./AccountGroupEditModal.vue?vue&type=script&lang=js&"
export * from "./AccountGroupEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports